import { createStyles } from "@mantine/core";
import { TooltipContent, TooltipRoot, TooltipTrigger, tokens } from "@blurb/codex-react";
import { IconV3 } from "@rpi/openapi-core";
import React from "react";

const useStyles = createStyles(() => ({
  // A span (not a div) so the trigger stays valid HTML inside inline contexts like <Body as="span">.
  trigger: {
    display: "inline-flex",
    alignItems: "center",
  },
}));

/**
 * Codex's compound tooltip inherits Base UI's 600ms open delay, which reads as "hovering does
 * nothing". Codex's own single-component `Tooltip` documents 300ms, so match that here.
 */
const HOVER_OPEN_DELAY_MS = 300;

interface FieldInfoTooltipProps {
  /** Field name, used to build the trigger's accessible name. */
  label: string;
  content: string;
}

/** An info "i" icon beside a field label that reveals an explanatory tooltip on hover or focus. */
export const FieldInfoTooltip: React.FC<FieldInfoTooltipProps> = ({ label, content }) => {
  const { classes } = useStyles();
  return (
    <TooltipRoot>
      <TooltipTrigger
        delay={HOVER_OPEN_DELAY_MS}
        render={
          <span className={classes.trigger} aria-label={`${label} information`} tabIndex={0}>
            <IconV3 icon="info" size={16} color={tokens.color.semantic.icon.subtle} />
          </span>
        }
      />
      <TooltipContent>{content}</TooltipContent>
    </TooltipRoot>
  );
};
